module.exports = __webpack_public_path__ + "img/other_teacher_bg.b4c2c6e7.png";